import {ModelMarketingData} from './model-marketing-data';

export class modelpageintroandcontent{
  pageintro: string;
  pagecontents: Array<ModelMarketingData> = [];
}
